import React from "react";

interface LogoProps {
	width?: number | string;
	height?: number | string;
	className?: string;
}

const Logo: React.FC<LogoProps> = ({ width = 93, height = 32, className }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 93 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M29.6567 0.53389L23.0835 6.20274L33.2673 16.3866V2.18673C33.2673 0.319056 31.0739 -0.685814 29.6602 0.53389H29.6567Z"
				fill="#00E5E5"
			/>
			<path
				d="M33.2568 16.3762L18.5926 31.0403C17.8857 31.7472 16.9363 32.0625 16.0146 31.9898L13.1247 17.6479C12.8995 16.5356 13.2668 15.3886 14.0949 14.6125L23.0729 6.18887L33.2602 16.3762H33.2568Z"
				fill="#2546EF"
			/>
			<path
				d="M13.2114 17.6479L16.1013 31.9898C15.3528 31.9309 14.6217 31.6121 14.05 31.0403L0.958957 17.9528C-0.319652 16.6742 -0.319652 14.6021 0.958957 13.3235L13.305 0.973957C14.5836 -0.304653 16.6592 -0.304653 17.9343 0.973957L23.1527 6.19235L14.1747 14.6159C13.3466 15.3921 12.9827 16.5356 13.2045 17.6513L13.2114 17.6479Z"
				fill="#006EFF"
			/>
			<rect
				x="70.7695"
				y="9.52228"
				width="2.30427"
				height="18.8153"
				rx="0.5"
				fill="#4B4B4B"
			/>
			<path
				d="M78.1919 5.59981V7.55758C78.1919 7.6546 78.2681 7.73083 78.3651 7.73083H89.883V24.8517C89.883 25.1948 89.7479 25.5239 89.5123 25.7561C89.294 25.9709 89.0098 26.0922 88.7118 26.0922H84.4602C84.3632 26.0922 84.2869 26.1685 84.2869 26.2655V28.2232C84.2869 28.3203 84.3632 28.3965 84.4602 28.3965H88.7118C89.6232 28.3965 90.4825 28.0396 91.1339 27.3951C91.8027 26.7298 92.1873 25.8046 92.1873 24.8517V6.29283C92.1873 5.81465 91.7992 5.42656 91.321 5.42656H78.3651C78.2681 5.42656 78.1919 5.50279 78.1919 5.59981H78.1919Z"
				fill="#4B4B4B"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M76.4661 11.1197H86.4039C86.5945 11.1197 86.7505 11.2756 86.7505 11.4662V21.9238C86.7505 22.1143 86.5945 22.2703 86.4039 22.2703H76.4661C76.2756 22.2703 76.1196 22.1143 76.1196 21.9238V11.4662C76.1196 11.2756 76.2756 11.1197 76.4661 11.1197ZM78.4239 19.9625H84.4462V13.4239H78.4239V19.9625Z"
				fill="#4B4B4B"
			/>
			<path
				d="M74.8862 4.40091H72.7379C72.6131 4.40091 72.53 4.52565 72.5785 4.64L74.0477 8.15011C74.0754 8.21595 74.1378 8.25753 74.2071 8.25753H76.3554C76.4801 8.25753 76.5633 8.13279 76.5148 8.01844L75.0491 4.50833C75.0214 4.44249 74.959 4.40091 74.8897 4.40091L74.8862 4.40091Z"
				fill="#4B4B4B"
			/>
			<path
				d="M54.6364 25.8774C51.9198 25.8774 50.1352 24.5399 49.1096 23.3999C49.1338 23.1538 49.1477 22.9044 49.1477 22.6514V11.0019C49.1477 10.5237 48.7596 10.1356 48.2814 10.1356H44.5496C44.501 10.1356 44.4629 10.1737 44.4629 10.2222V12.3532C44.4629 12.4017 44.501 12.4399 44.5496 12.4399H46.8434V22.6549C46.8434 23.3756 46.7014 24.0409 46.4242 24.6265C45.8316 25.8774 44.7367 26.0576 44.4317 26.0853C44.3867 26.0888 44.3521 26.1269 44.3521 26.1719V28.296C44.3521 28.348 44.3971 28.3896 44.4491 28.3826C44.9862 28.3133 47.6057 27.8698 48.3681 25.8843C49.6259 26.955 51.7049 28.1851 54.626 28.1851C54.6676 28.1851 54.7022 28.1851 54.7334 28.1851H67.3185C67.367 28.1851 67.4051 28.147 67.4051 28.0985V25.9675C67.4051 25.919 67.367 25.8809 67.3185 25.8809H54.6398L54.6364 25.8774Z"
				fill="#4B4B4B"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M66.7192 21.7436C65.6589 21.6535 62.7794 19.9071 60.3088 18.1191H65.9326C66.1232 18.1191 66.2791 17.9632 66.2791 17.7726V10.4682C66.2791 10.2777 66.1232 10.1217 65.9326 10.1217H60.0489V8.75995H66.8266C66.8751 8.75995 66.9132 8.72184 66.9132 8.67333V6.54231C66.9132 6.4938 66.8751 6.45568 66.8266 6.45568H60.0489V4.1133C60.0489 4.06479 60.0108 4.02667 59.9623 4.02667H57.8313C57.7828 4.02667 57.7447 4.06479 57.7447 4.1133V6.45568H50.967C50.9185 6.45568 50.8804 6.4938 50.8804 6.54231V8.67333C50.8804 8.72184 50.9185 8.75995 50.967 8.75995H57.7447V10.1217H51.861C51.6704 10.1217 51.5145 10.2777 51.5145 10.4682V17.7726C51.5145 17.9632 51.6704 18.1191 51.861 18.1191H56.6913C55.1216 19.7754 51.6704 21.7644 51.2442 22.0069C51.2165 22.0208 51.1992 22.052 51.1992 22.0831V24.3112C51.1992 24.377 51.265 24.4186 51.3239 24.3909C52.0273 24.0409 55.5859 22.2287 57.7447 20.1877V25.0908C57.7447 25.1393 57.7828 25.1774 57.8313 25.1774H59.9623C60.0108 25.1774 60.0489 25.1393 60.0489 25.0908V20.7526C62.2319 22.2599 65.0733 23.9889 66.7053 24.0513C66.7538 24.0513 66.7954 24.0132 66.7954 23.9612V21.8267C66.7954 21.7817 66.7608 21.747 66.7157 21.7401L66.7192 21.7436ZM57.7481 15.8148H53.8257V12.4295H57.7481V15.8148ZM63.9749 12.426H60.0524V15.8114H63.9749V12.426Z"
				fill="#4B4B4B"
			/>
			<path
				d="M49.5184 8.13625L47.9799 4.45289C47.9661 4.4217 47.9349 4.40091 47.9002 4.40091H45.5613C45.4989 4.40091 45.4574 4.46328 45.4816 4.52219L47.0236 8.20555C47.0374 8.23674 47.0686 8.25753 47.1033 8.25753H49.4387C49.5011 8.25753 49.5427 8.19516 49.5184 8.13625V8.13625Z"
				fill="#4B4B4B"
			/>
		</svg>
	);
};

export default Logo;
